import {
  ArrangementsAuthData,
  ErrorText,
  InventoryAuthData,
  SalesAuthData,
} from './constants';

/**
 * Updates input field value and error in the form state
 * @param  {event}
 * @param  {object} payloadState
 * @param  {func} checkValueBeforeSet {field validation}
 */
function changeInputHandler({ target }, payloadState = {}, setState, checkValueBeforeSet = (value) => value) {
  const { id, value } = target;
  const newValue = checkValueBeforeSet(value);

  if (newValue === '' || newValue) {
    setState({
      ...payloadState,
      [id]: newValue,
      [`${id}Error`]: false,
      [`${id}ErrorMsg`]: '',
    });
  }
}

function validateField(
  { target: { id = '', value = '' } = {} } = {},
  payloadState = {},
  setState,
  fieldIsValid = () => true,
  invalidMessage = '',
  validateEmptyField = false,
  emptyFieldErrorMessage = ErrorText.FIELD_IS_REQUIRED,
) {
  if (!validateEmptyField && !value) {
    return;
  }

  if (!fieldIsValid(value) || (validateEmptyField && !value)) {
    setState({
      ...payloadState,
      [`${id}Error`]: true,
      [`${id}ErrorMsg`]: validateEmptyField && !value ? emptyFieldErrorMessage : invalidMessage,
    });
  }
}

function clearStorage() {
  localStorage.setItem(SalesAuthData.USER, '');
  localStorage.setItem(SalesAuthData.TOKEN, '');
  localStorage.setItem(InventoryAuthData.USER, '');
  localStorage.setItem(InventoryAuthData.TOKEN, '');
  localStorage.setItem(ArrangementsAuthData.USER, '');
  localStorage.setItem(ArrangementsAuthData.TOKEN, '');
}

function setPromiseAllSettled() {
  Promise.allSettled = (promises) => (
    Promise.all(promises.map((p) => Promise.resolve(p).then((value) => ({
      status: 'fulfilled',
      value,
    }), (error) => ({
      status: 'rejected',
      reason: error,
    }))))
  );
}

export {
  changeInputHandler,
  clearStorage,
  setPromiseAllSettled,
  validateField,
};
